type Context = 'integration';

type Section = 'field-groups';

type Value = `${Context}-${Section}`;

export const Keys: Record<Section, Value> = {
  'field-groups': 'integration-field-groups',
};
